<template>
    <client-page>

        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Active & Legging Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Active & Legging Line" file="active">
                프린팅과 포일 디자인을 더한 싱글/더블 니트, 다양한 패턴의 엠보싱, 고신축성과 리커버리를 가진 아이템. 스포츠 및 레깅스 아이템에 대해 경험이 풍부하며 합리적인 가격으로  많은 브랜드와 협력하고 있습니다.
            </sub-product>
        </sub-section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped>
</style>
